import { render, staticRenderFns } from "./UnKnowTable.vue?vue&type=template&id=3db3cfe6&scoped=true&"
import script from "./UnKnowTable.vue?vue&type=script&lang=js&"
export * from "./UnKnowTable.vue?vue&type=script&lang=js&"
import style0 from "./UnKnowTable.vue?vue&type=style&index=0&id=3db3cfe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db3cfe6",
  null
  
)

export default component.exports